/**
 * Kiosk home suggested-card frame (see kiosk-app suggestedCardLayout.ts):
 * 5:2 banner — wider than activity gallery 16:9.
 */
export const CAROUSEL_SLIDE_IMAGE_ASPECT = 5 / 2;

/**
 * Fits ~3 lines of `text-2xl` bold on the kiosk SuggestedCard
 * (`numberOfLines={3}`). Keep titles short so they are not clipped.
 */
export const CAROUSEL_SLIDE_TITLE_MAX_LENGTH = 90;

/** Matches kiosk carousel description truncation (`KIOSK_SUGGESTION_DESCRIPTION_MAX_CHARS`). */
export const CAROUSEL_SLIDE_DESCRIPTION_MAX_LENGTH = 200;
